import * as React from "react"
import PropTypes from "prop-types"

import Adam from "./adam"
import Testimony from "./testimonies/index";
import Menu from "./menu"
import SearchFooter from "./search";

const Footer = ({pageID=0}) => (
  <footer>
    {2 !== pageID && <Adam />}
    <Testimony />
    <Menu />
    <SearchFooter />
  </footer>
)

Footer.propTypes = {
  pageID: PropTypes.number,
}

export default Footer
